import { MetricCard } from './MetricCard'

interface IUsersPlayingCard {
  metric: string
}

export const UsersPlayingCard = ({ metric }: IUsersPlayingCard) => {
  return <MetricCard title="Users Playing" metric={metric} icon="group" />
}
